import React, { useEffect, useMemo, useState, useRef, useCallback } from "react"
import {
   Col,
   Container,
   Form,
   Row,
   Table,
   DropdownButton,
   Button,
   ListGroup,
   Dropdown,
   Pagination,
} from "react-bootstrap"
import { Link, useNavigate } from "react-router-dom"
import { addBreadCrumbLinks } from "../commonComponents/EventHandler"
import ExportToExcel from "../vendorInfo/ExportToExcel"
import CommonView from "./CommonView"
import { EXCEL_VENDOR_DATA } from "../../constant/Constants"

import {
   PendingViewActions,
   SummaryViewActions,
   FavoritesViewActions,
   RejectedViewActionsInternals,
   MOVE_REMOVE_API,
   EBP_VIEW_PDF_DOWNLOAD,
   FETCH_VENDOR_PREFERENCE,
   FETCH_VENDOR_ORGANIZATIONs,
   Highly_CONNECTED_API,
   EMAIL_DATA,
} from "../../constant/Constants"
import {
   fetchAPIData,
   MoveRemoveAPI,
   isLoggedIn,
   EBPViewPdfDownload,
   highlyConnectedMessage,
   EBPIDsForEmail,
} from "../../api/AuthService"
import OrganizationData from "./OrganizationData"
import VendorMailModal from "./VendorMailModal"
import UnrejectModal from "./UnrejectModal"
import { saveAs } from "file-saver"
import ExportToExcelAllSpecifications from "./ExportToExcelAllSpecifications"

const VendorResults = ({
   view,
   results,
   error,
   downloadData,
   handleViewMorePart,
   fromViewMore,
   siteInfo,
   fetchDataOrganization,
   searchBox,
}) => {
   const [downloadExcelData, setdownloadExcelData] = useState()
   const [loadingExcelData, setLoadingExcelData] = useState(true)
   const navigate = useNavigate()
   async function fetchDataAllSpecificationData() {
      try {
         if (siteInfo) {
            setLoadingExcelData(true)
            const Exceldata = await fetchAPIData(
               `${EXCEL_VENDOR_DATA}/${sbmView}?companyName=${encodeURIComponent(siteInfo)}&organization=empty`,
            )
            if (Exceldata.data?.pending.length != 0) {
               setdownloadExcelData(Exceldata.data)
               setLoadingExcelData(false)
            } else {
               setLoadingExcelData(false)
            }
         }
      } catch (error) {
         setLoadingExcelData(false)
      }
   }
   const useSortableData = (items, config = null) => {
      const [sortConfig, setSortConfig] = useState(config)
      const sortedItems = useMemo(() => {
         let sortableItems = [...items]
         if (sortConfig !== null) {
            sortableItems.sort((a, b) => {
               if (sortConfig.key === "ReleaseDate" || sortConfig.key === "EBPModified") {
                  if (new Date(a[sortConfig.key]) < new Date(b[sortConfig.key])) {
                     return sortConfig.direction === "ascending" ? -1 : 1
                  }
                  if (new Date(a[sortConfig.key]) > new Date(b[sortConfig.key])) {
                     return sortConfig.direction === "ascending" ? 1 : -1
                  }
                  return 0
               } else {
                  if (a[sortConfig.key] < b[sortConfig.key]) {
                     return sortConfig.direction === "ascending" ? -1 : 1
                  }
                  if (a[sortConfig.key] > b[sortConfig.key]) {
                     return sortConfig.direction === "ascending" ? 1 : -1
                  }
                  return 0
               }
            })
         }
         return sortableItems
      }, [items, sortConfig])

      const requestSort = (key) => {
         let direction = "descending"
         if (
            sortConfig &&
            sortConfig.key === key &&
            sortConfig.direction === "descending"
         ) {
            direction = "ascending"
         }
         setSortConfig({ key, direction })
      }
      return { items: sortedItems, requestSort, sortConfig }
   }

   const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
   ]

   const [resultsPerPage, setResultsPerPage] = useState(20)
   const [currentPage, setCurrentPage] = useState(1)
   const indexOfLastResult = currentPage * resultsPerPage
   const indexOfFirstResult = indexOfLastResult - resultsPerPage
   const [filteredData, setFilteredData] = useState([])
   const [selected, setSelected] = useState([])
   const [activePage, setActivePage] = useState(1)
   const [message, setMessage] = useState("")
   const [success, setSuccess] = useState(false)
   const employee = localStorage.getItem("employee") ? atob(localStorage.getItem("employee")) : null
   const userRole = localStorage.getItem("role")
   const [dynamicAction, setDynamicAction] = useState(PendingViewActions)
   const [show, setShow] = useState(false)
   const [moveData, setMoveData] = useState({})
   const [pdfDisable, setPdfDisable] = useState(false)

   const [vendors, setVendors] = useState([])
   const dataRef = useRef(vendors)
   const [search, setSearch] = useState("")
   const [searchedVendors, setSearchedVendors] = useState([])
   const [loading, setLoading] = useState(false)
   const [errorPreferance, setErrorPreferance] = useState()
   const [showUnrejectModal, setShowUnrejectModal] = useState(false)

   const [selectedRowIds, setSelectedRowIds] = useState([])
   const [selectedNames, setSelectedNames] = useState([])
   const [selectAllRows, setSelectAllRows] = useState(false)
   const [sendSelectedIds, setSendSelectedIds] = useState([])
   const [showOrganization, setShowOrganization] = useState(false)
   const [orgName, setOrgName] = useState("")
   const [showDateRangeFields, setShowDateRangeFields] = useState(true)
   const [showDateRangeFieldsMsg, setShowDateRangeFieldsMsg] = useState(false)
   const [showPreferenceDateMsg, setShowPreferenceDateMsg] = useState(false)
   const [showVendorContent, setShowVendorContent] = useState(true)

   const handleCloseOrganization = () => setShowOrganization(false)
   const handleOU = () => {
      handleShowOrganization()
      setSearch("")
   }
   const handleShowOrganization = () => setShowOrganization(true)
   const getOrganization = (name) => {
      if (name && typeof name === 'string') {
         setOrgName(name)
      }
   }

   const releaseDateArray = (results || [])
      .filter((item) => item && item.EBPModified !== null)
      .map((item) => item.EBPModified)

   const releaseDateObjects = releaseDateArray.length > 0
      ? releaseDateArray.map((date) => new Date(date))
      : [new Date()]

   const _today = new Date()
   const todayStr = `${_today.getFullYear()}-${String(_today.getMonth() + 1).padStart(2, "0")}-${String(_today.getDate()).padStart(2, "0")}`
   const todayYearMonth = `${_today.getFullYear()}-${String(_today.getMonth() + 1).padStart(2, "0")}`

   const [filterDates, setFilterDates] = useState({
      fromdateformat: "",
      todateformat: "",
      selectdateformat: "",
      sortDateByRange: false,
      sortByDate: false,
      sortByDateMessage: false,
      sortDateByRangeMessage: false,
      sortByMonth: false,
      sortByMonthMessage: false,
      firstOfMonth: "",
      lastOfMonth: "",
      filtered: false,
   })

   const searchChanges = (e) => {
      setShowVendorContent(true)
      setOrgName(e.target.value)
      setSearch(e.target.value)
   }

   const [searchData, setSearchData] = useState("")
   const [regSearch, setRegSearch] = useState(false)

   const [dataSearched, setDataSearched] = useState([])
   const [actualFilteredData, setActualFilteredData] = useState([])

   const inputRef = useRef()
   const prefFilterApplied = useRef(false)
   const [searching, setSearching] = useState(false)
   const [showFilter, setShowFilter] = useState(true)
   const [showMonthField, setShowMonthField] = useState(true)
   const [showMonthFieldMsg, setShowMonthFieldMsg] = useState(false)
   const userType = localStorage.getItem("userType")
   const sbmView = sessionStorage.getItem("view")
   const [showDateField, setShowDateField] = useState(true)
   const [showDateFieldMsg, setShowDateFieldMsg] = useState(false)
   // const organizationNameData = sessionStorage.getItem("organization")

   function handleSearchChange(e) {
      setSearching(true)
      setRegSearch(true)
      setShowFilter(false)
      if (e.target.value === "") {
         setShowFilter(true)
      }
      setSearchData(e.target.value)
      let vendorSearch = e.target.value
      let vSearch = vendorSearch.replace(/([|\\^$*+?.(){}[\]\-\_~&])/g, "\\$1")
      var re1 = new RegExp(vSearch, "i")
      var regData =
         view === "Pending"
            ? currentResults.length !== 0
               ? currentResults
               : (results || [])
            : results

      var matches = regData.filter(
         matcher(re1, ["Name", "Type", "Title", "ReasonForChange"]),
      )
      setDataSearched(matches)
      if (inputRef.current.value) {
         setFilteredData(actualFilteredData)
      }

      setActivePage(1)
      setCurrentPage(1)
   }

   function matcher(regexp, columns) {
      return function (obj) {
         var found = false
         columns.forEach(function (column) {
            if (
               !found &&
               obj[column] &&
               typeof obj[column] === "string" &&
               regexp.exec(obj[column])
            ) {
               found = true
            }
         })
         return found
      }
   }

   function dateCheck(from, to, check) {
      let fDate, lDate, cDate
      fDate = Date.parse(from)
      lDate = Date.parse(to)
      cDate = Date.parse(check)
      if (cDate <= lDate && cDate >= fDate) {
         return true
      }
      return false
   }

   const handleSelect = (e, key) => {
      e.preventDefault()
      setOrgName(key.name)
      setShowVendorContent(false)
      setActivePage(1)
      setCurrentPage(1)
      sessionStorage.setItem("organization", key.name)
   }

   const vendor_content = searchedVendors.map((key, index) => (
      <ListGroup.Item
         onClick={(e) => handleSelect(e, key)}
         key={index + 1}
         className={orgName === key.name ? "selected" : ""}
      >
         {key.name}
      </ListGroup.Item>
   ))

   const handlefromdate = (e) => {
      const getfromdatevalue = e.target.value
      // If the user cleared the from date, reset fromdateformat and return
      if (getfromdatevalue === "") {
         setFilterDates((dates) => ({ ...dates, fromdateformat: "" }))
         return
      }
      // Guard: from date cannot be after to date or in the future
      if (getfromdatevalue > todayStr) return
      if (filterDates.todateformat) {
         const toAsInput = toInputDate(filterDates.todateformat)
         if (toAsInput && getfromdatevalue > toAsInput) return
      }
      const setfromformat = getfromdatevalue.split("-")
      const setfromyear = setfromformat[0]
      const setfrommonth = setfromformat[1]
      const setfromdate = setfromformat[2]
      const setfromformatdate = setfrommonth + "/" + setfromdate + "/" + setfromyear
      setFilterDates((dates) => ({
         ...dates,
         fromdateformat: setfromformatdate,
      }))
   }
   function hideAllFilterMessages() {
      setShowDateRangeFieldsMsg(false)
      setShowDateFieldMsg(false)
      setShowMonthFieldMsg(false)
   }

   const handleSortByDateRange = () => {
      handleClearFilter()
      hideAllFilterMessages()
      setShowDateRangeFields(true)
      setFilterDates((dates) => ({
         ...dates,
         fromdateformat: "",
         todateformat: "",
         sortDateByRange: true,
         sortByDateMessage: false,
         sortByMonthMessage: false,
         sortDateByRangeMessage: true,
         filtered: false,
      }))
      if (filterDates.sortByDate) {
         setFilterDates((dates) => ({
            ...dates,
            sortByDate: false,
         }))
      }
      if (filterDates.sortByMonth) {
         setFilterDates((dates) => ({
            ...dates,
            sortByMonth: false,
         }))
      }
   }

   const handleSortByDate = () => {
      setShowDateField(true)
      handleClearFilter()
      hideAllFilterMessages()
      setDataSearched([])
      inputRef.current.value = ""
      setFilterDates((dates) => ({
         ...dates,
         selectdateformat: "",
         sortByDate: true,
         sortByDateMessage: false,
         sortByMonthMessage: false,
         sortDateByRangeMessage: false,
         filtered: false,
      }))
      if (filterDates.sortDateByRange) {
         setFilterDates((dates) => ({
            ...dates,
            sortDateByRange: false,
         }))
      }
      if (filterDates.sortByMonth) {
         setFilterDates((dates) => ({
            ...dates,
            sortByMonth: false,
         }))
      }
   }

   const handleSortByMonth = () => {
      setShowMonthField(true)
      handleClearFilter()
      hideAllFilterMessages()
      setFilterDates((dates) => ({
         ...dates,
         firstOfMonth: "",
         lastOfMonth: "",
         sortByMonth: true,
         sortByDateMessage: false,
         sortByMonthMessage: false,
         sortDateByRangeMessage: false,
         filtered: false,
      }))
      if (filterDates.sortDateByRange) {
         setFilterDates((dates) => ({
            ...dates,
            sortDateByRange: false,
         }))
      }
      if (filterDates.sortByDate) {
         setFilterDates((dates) => ({
            ...dates,
            sortByDate: false,
         }))
      }
   }

   const handletodate = (e) => {
      const gettodatevalue = e.target.value
      // If the user cleared the to date, reset todateformat and return
      if (gettodatevalue === "") {
         setFilterDates((dates) => ({ ...dates, todateformat: "" }))
         return
      }
      // Guard: to date cannot be before from date or in the future
      if (gettodatevalue > todayStr) return
      if (filterDates.fromdateformat) {
         const fromAsInput = toInputDate(filterDates.fromdateformat)
         if (fromAsInput && gettodatevalue < fromAsInput) return
      }
      const setdateformat = gettodatevalue.split("-")
      const settoyear = setdateformat[0]
      const settomonth = setdateformat[1]
      const settodate = setdateformat[2]
      const settodateformat = settomonth + "/" + settodate + "/" + settoyear
      setFilterDates((dates) => ({
         ...dates,
         todateformat: settodateformat,
      }))
   }

   const handleDateByRange = (e) => {
      e.preventDefault()
      if (filterDates.fromdateformat != "" && filterDates.todateformat != "") {
         setFilterDates((dates) => ({
            ...dates,
            sortDateByRange: true,
            filtered: true,
         }))
         setShowDateRangeFields(false) // Hide the fields
         setShowDateRangeFieldsMsg(true)
      } else if (filterDates.fromdateformat != "" && filterDates.todateformat == "") {
         const today = new Date()
         const todayFormatted = `${String(today.getMonth() + 1).padStart(2, "0")}/${String(today.getDate()).padStart(2, "0")}/${today.getFullYear()}`
         setFilterDates((dates) => ({
            ...dates,
            todateformat: todayFormatted,
            sortDateByRange: true,
            filtered: true,
         }))
         setShowDateRangeFields(false) // Hide the fields
         setShowDateRangeFieldsMsg(true)
      } else if (filterDates.fromdateformat == "" && filterDates.todateformat != "") {
         const oldestReleaseDate = new Date(Math.min.apply(null, releaseDateObjects))
         const oldestDateFormatted = `${String(oldestReleaseDate.getMonth() + 1).padStart(2, "0")}/${String(oldestReleaseDate.getDate()).padStart(2, "0")}/${oldestReleaseDate.getFullYear()}`
         const fromDate = oldestDateFormatted
         setFilterDates((dates) => ({
            ...dates,
            fromdateformat: fromDate,
            sortDateByRange: true,
            filtered: true,
         }))
         setShowDateRangeFields(false) // Hide the fields
         setShowDateRangeFieldsMsg(true)
      } else {
         alert("Please enter both From Date and To Date.")
      }
   }

   const rangeDataDisplay = (start, end, toFilterDate) => {
      setFilterDates((dates) => ({
         ...dates,
         filtered: true,
      }))
      const filteredDateData = results.filter((item) => {
         if (item.EBPModified) {
            const setFilterDate = item.EBPModified.split(" ")[0].split("/")
            const settomonth = setFilterDate[0]
            const settodate = setFilterDate[1]
            const settoyear = setFilterDate[2]
            toFilterDate = settomonth + "/" + settodate + "/" + settoyear
            return dateCheck(start, end, toFilterDate)
         } else {
            return true
         }
      })
      setActualFilteredData(filteredDateData)
      const searchFilterData = filteredDateData.filter((item) =>
         dataSearched.includes(item),
      )
      setFilteredData(inputRef.current.value !== "" ? searchFilterData : filteredDateData)

      setFilterDates((dates) => ({
         ...dates,
         sortDateByRange: false,
         sortDateByRangeMessage: true,
      }))
      setDataSearched([])
   }

   const handleSelectDate = (e) => {
      const getSelectDateValue = e.target.value
      const setSelectFormat = getSelectDateValue.split("-")
      const setSelectYear = setSelectFormat[0]
      const setSelectMonth = setSelectFormat[1]
      const setSelectDate = setSelectFormat[2]
      const setSelectFormatDate = `${setSelectMonth}/${setSelectDate}/${setSelectYear}`
      setFilterDates((dates) => ({
         ...dates,
         selectdateformat: setSelectFormatDate,
      }))
   }

   const handleSelectDateSubmit = (e) => {
      e.preventDefault()
      if (filterDates.selectdateformat) {
         setFilterDates((dates) => ({
            ...dates,
            sortByDate: true,
            filtered: true,
         }))
         setShowDateField(false) // Hide the "Select Date*" field
         setShowDateFieldMsg(true)
      } else {
         alert("Please select a Date.")
      }
   }

   const handleSelectMonth = (e) => {
      const getSelectDateValue = e.target.value
      const setMonthFormat = getSelectDateValue.split("-")

      const setYear = setMonthFormat[0]
      const setMonth = setMonthFormat[1]

      const firstDay = new Date(setYear, parseInt(setMonth, 10) - 1, 1)
      const lastDay = new Date(setYear, parseInt(setMonth, 10), 0)

      const firstDateString = `${setMonth}/${firstDay.getDate()}/${setYear}`
      const lastDateString = `${setMonth}/${lastDay.getDate()}/${setYear}`

      setFilterDates((dates) => ({
         ...dates,
         firstOfMonth: firstDateString,
         lastOfMonth: lastDateString,
      }))
   }

   const fetchTOandCC = async (ids) => {
      const data = {
         objectId: Array.isArray(ids) ? ids : [ids],
      }
      try {
         const response = await EBPIDsForEmail(`${EMAIL_DATA}`, data)
         if (response.data) {
            return { To: response.data.To, CC: response.data.CC }
         }
         return null
      } catch (error) {
         console.error("API error", error)
         return null
      }
   }

   async function highlyConnectedMessageFunction() {
      const ToandCCData = await fetchTOandCC(currentResult[0].id)
      const fullName = localStorage.getItem("User")
      const userName = localStorage.getItem("UserId")
      const role = localStorage.getItem("role")
      const employee = localStorage.getItem("employee") ? atob(localStorage.getItem("employee")) : null
      const hir_compliant = localStorage.getItem("hir_compliant")
      const data = {
         userRole: role != "" ? role : employee,
         plantName: siteInfo,
         partName: searchBox,
         userName: userName,
         to: ToandCCData.To.join(","),
         cc: ToandCCData.CC.join(","),
         fullName: fullName,
         hir_compliant: hir_compliant ? hir_compliant : "",
      }
      highlyConnectedMessage(`${Highly_CONNECTED_API}`, data)
         .then((response) => {
            if (response.data) {
               alert("Email sent successfully.")
            }
         })
         .catch((error) => {
            alert(
               "There is an issue with the search service. Please contact SpecReaderExt.im@pg.com for help.",
            )
            if (error.response && error.response.status) {
               console.log(error.response.status, error.response.data.message)
            } else {
               console.log(1000, error)
            }
         })
   }

   const fetchData = async () => {
      try {
         setLoading(true)
         const response = await fetchAPIData(`${FETCH_VENDOR_ORGANIZATIONs}`)

         if (response.data && response.data.length !== 0) {
            const sortedOrganizations = response.data.organizations?.sort((a, b) => {
               if (a.name.toLowerCase() < b.name.toLowerCase()) return -1
               if (a.name.toLowerCase() > b.name.toLowerCase()) return 1
               return 0
            })
            setVendors(sortedOrganizations)
            setLoading(false)
            setErrorPreferance(0)
         } else {
            setErrorPreferance(1)
         }
      } catch (error) {
         setLoading(false)
         setErrorPreferance(2)
      }
   }

   const debounce = (func, delay = 300) => {
      let timeout
      return (...args) => {
         clearTimeout(timeout)
         timeout = setTimeout(() => {
            func.apply(null, args)
         }, delay)
      }
   }

   const handleSearchChange1 = useCallback(
      debounce((search) => {
         const data = dataRef.current
         if (search !== "") {
            let escapedSearch = search.replace(/([|\\^$*+?.(){}[\]\-\_~&])/g, "\\$1")
            let regex = new RegExp(escapedSearch, "i")
            var matches = data.filter((vendor) => regex.test(vendor.name))
            setSearchedVendors(matches)
         } else {
            setSearchedVendors([])
         }
      }),
      [],
   )

   const handleMonthSubmit = (e) => {
      e.preventDefault()
      if (filterDates.firstOfMonth && filterDates.lastOfMonth) {
         setFilterDates((dates) => ({
            ...dates,
            sortByMonth: true,
            filtered: true,
         }))
         setShowMonthField(false) // Hide the "Select Month*" field
         setShowMonthFieldMsg(true)
      } else {
         alert("Please select a Month and Year.")
      }
   }

   let currentResults
   if (view === "Pending") {
      currentResults = filterDates.filtered
         ? filteredData.sort((a, b) => new Date(b.EBPModified) - new Date(a.EBPModified))
         : (results || []).sort(
            (a, b) => new Date(b.EBPModified) - new Date(a.EBPModified),
         )

      // Filter by Date
      if (filterDates.sortByDate && filterDates.selectdateformat) {
         currentResults = results.filter((item) => {
            if (item.EBPModified) {
               const itemDate = new Date(item.EBPModified.split(" ")[0])
               const selectedDate = new Date(filterDates.selectdateformat)
               return itemDate.toDateString() === selectedDate.toDateString()
            }
            return false
         })
      }

      // Filter by Date Range
      if (
         filterDates.sortDateByRange &&
         filterDates.fromdateformat &&
         filterDates.todateformat
      ) {
         currentResults = results.filter((item) => {
            if (item.EBPModified) {
               const itemDate = new Date(item.EBPModified.split(" ")[0])
               const fromDate = new Date(filterDates.fromdateformat)
               const toDate = new Date(filterDates.todateformat)
               return itemDate >= fromDate && itemDate <= toDate
            }
            return false
         })
      }

      // Filter by Month
      if (
         filterDates.sortByMonth &&
         filterDates.firstOfMonth &&
         filterDates.lastOfMonth
      ) {
         currentResults = results.filter((item) => {
            if (item.EBPModified) {
               const itemDate = new Date(item.EBPModified.split(" ")[0])
               const fromDate = new Date(filterDates.firstOfMonth)
               const toDate = new Date(filterDates.lastOfMonth)
               return itemDate >= fromDate && itemDate <= toDate
            }
            return false
         })
      }

      // Filter by Organization
      if (orgName.trim() !== "") {
         currentResults = currentResults.filter((item) => {
            const organizations = item.organization ? item.organization.split(",") : []
            return organizations.some(
               (org) => org.trim().toLowerCase() === orgName.trim().toLowerCase(),
            )
         })
      }

      // Sort the filtered results
      currentResults = currentResults.sort(
         (a, b) => new Date(b.EBPModified) - new Date(a.EBPModified),
      )
   } else {
      currentResults = results.sort(
         (a, b) => new Date(b.EBPModified) - new Date(a.EBPModified),
      )
   }

   var searchInput = inputRef?.current?.value

   let finalData
   if (dataSearched.length) {
      finalData = dataSearched.sort(
         (a, b) => new Date(b.EBPModified) - new Date(a.EBPModified),
      )
   } else if (searchInput !== undefined && filteredData.length == 0) {
      finalData = dataSearched
   } else if (filteredData.length !== 0) {
      if (searchInput) {
         finalData = dataSearched
      } else {
         finalData = currentResults
      }
   } else {
      finalData = currentResults
   }

   if (searchInput === "" && filteredData.length === 0) {
      finalData = currentResults
   }

   const { items, requestSort, sortConfig } = useSortableData(finalData)

   const currentResult = items.slice(indexOfFirstResult, indexOfLastResult)

   const exportData = items

   function handlePDFDownload(Name, Link, Id, Rev) {
      if (!isLoggedIn()) {
         navigate("/")
      } else {
         setPdfDisable(true)
         let fileName = "download"
         fileName = Name ? (Rev ? Name + "-Rev" + Rev : Name) : fileName
         const data = {
            Name: Name,
            Rev: Rev,
            Id: Id,
            Type: Link,
         }
         EBPViewPdfDownload(`${EBP_VIEW_PDF_DOWNLOAD}`, data)
            .then((response) => 
               {
               if(response.status === 202){
                  alert("As the Consolidated Packaging View PDF is huge, the PDF will be emailed to you in some time.")
               }
               else{
                  const blob = new Blob([response.data], {
                     type: "application/pdf",
                  })
                  let fileContents = URL.createObjectURL(blob)
                  saveAs(fileContents, fileName)
               }
               setPdfDisable(false)
            })
            .catch((error) => {
               if (error.response && error.response.status === 422) {
                  //setShow(true)
                  alert(
                     "You have exceeded the limit for the day and access to any additional Part/Specification is blocked! Please wait until the limit resets tomorrow or contact SpecReaderExt.im@pg.com and request the limit be reset.",
                  )
               } if(error.response && error.response.status === 202){
                  alert("As the Consolidated Packaging View PDF is huge, the PDF will be emailed to you in some time.")
               }
               else if (error.response && error.response.data.status === 401) {
                  navigate("/")
               } else {
                  alert(
                     "There is an issue downloading the file.Please contact SpecReaderExt.im@pg.com for help.",
                  )
                  console.log(" error", error)
               }
               setPdfDisable(false)
            })
      }
   }
   const handleHeaderCheckBoxChange = () => {
      if (selectAllRows) {
         setSendSelectedIds([])
         setSelectedRowIds([])
         setSelectedNames([])
      } else {
         const allRowIds = finalData.map((row) => row.ebpId)
         const allNames = finalData.map((row) => row.Name)
         const allPlainIds = finalData.map((row) => row.Id)

         setSelectedRowIds(allRowIds)
         setSelectedNames(allNames)
         setSendSelectedIds(allPlainIds)
      }
      setSelectAllRows(!selectAllRows)
   }

   const handleRowCheckBoxChange = (rowId, rowName, plainId) => {
      const updatedSelectedRowIds = selectedRowIds.includes(rowId)
         ? selectedRowIds.filter((id) => id !== rowId)
         : [...selectedRowIds, rowId]
      setSelectedRowIds(updatedSelectedRowIds)

      // Check if ALL items across ALL pages are selected (not just current page)
      const allRowsSelected = finalData.every((row) =>
         updatedSelectedRowIds.includes(row.ebpId),
      )

      const updatedSelectedNames = selectedNames.includes(rowName)
         ? selectedNames.filter((name) => name !== rowName)
         : [...selectedNames, rowName]
      setSelectedNames(updatedSelectedNames)

      setSelectAllRows(allRowsSelected)

      const sendSelectedPlainIds = sendSelectedIds.includes(plainId)
         ? sendSelectedIds.filter((id) => id !== plainId)
         : [...sendSelectedIds, plainId]

      setSendSelectedIds(sendSelectedPlainIds)
   }

   const isChecked = (value) => {
      if (value === "All") {
         return selectAllRows
      } else {
         return selectedRowIds.includes(value) ? true : false
      }
   }

   const getClassNamesFor = (name) => {
      if (!sortConfig) {
         return "fa fa-sort"
      } else if (sortConfig.key === name) {
         if (sortConfig.direction === "ascending") {
            return "fa fa-caret-up"
         } else {
            return "fa fa-caret-down"
         }
      } else {
         return "fa fa-sort"
      }
   }
   const impacted_content = currentResult && currentResult.length && currentResult[0].ImpactedParts ? (
      currentResult[0].ImpactedParts.length ? (
         currentResult[0].ImpactedParts.map((key, index) => {
            if (!key) return null

            return (
               <tr key={index}>
                  <td width="10%">
                     {key.link != null && key.id != null ? (
                        <Link
                           target="_blank"
                           rel="noreferrer noopener"
                           onClick={() =>
                              addBreadCrumbLinks(
                                 key.Name || "",
                                 `/${key.link.toUpperCase().trim()}/${key.id.trim()}`,
                              )
                           }
                           to={`/${key.link.toUpperCase()}/${key.id}`}
                        >
                           <span textalign="left">{key.Name || "N/A"}</span>
                        </Link>
                     ) : (
                        <span>{key.Name || "N/A"}</span>
                     )}
                  </td>
                  <td align="left" width="10%">
                     {key.DisplayType || ""}
                  </td>
                  <td align="left" width="5%">
                     {key.Revision || ""}
                  </td>
                  <td align="left" width="10%">
                     {key.Title || ""}
                  </td>
               </tr>
            )
         }).filter(Boolean)
      ) : (
         <tr>
            <td align="left" width="10%">{""}</td>
            <td align="left" width="10%">{""}</td>
            <td align="left" width="5%">{""}</td>
            <td align="left" width="10%">{""}</td>
         </tr>
      )
   ) : (
      <tr>
         <td align="left" width="10%">{""}</td>
         <td align="left" width="10%">{""}</td>
         <td align="left" width="5%">{""}</td>
         <td align="left" width="10%">{""}</td>
      </tr>
   )

   const info_content = (currentResult || []).map((key, index) => {
      if (!key) return null

      return (
         <tr key={index}>
            <td width="10%">
               {key.link != null && key.id != null ? (
                  <Link
                     target="_blank"
                     rel="noreferrer noopener"
                     onClick={() =>
                        addBreadCrumbLinks(
                           key.Name || "",
                           `/${key.link.toUpperCase().trim()}/${key.id.trim()}`,
                        )
                     }
                    to={`/${key.link.toUpperCase().trim()}/${key.id.trim()}`}
                  >
                     <span textalign="left">{key.Name || "N/A"}</span>
                  </Link>
               ) : (
                  <span>{key.Name || "N/A"}</span>
               )}
            </td>
            <td align="left" width="10%">
               {key.Type || ""}
            </td>
            <td align="left" width="5%">
               {key.Rev || ""}
            </td>
            <td align="left" width="10%">
               {key.Title || ""}
            </td>
         </tr>
      )
   }).filter(Boolean)

   function moveFromView(data) {
      MoveRemoveAPI(`${MOVE_REMOVE_API}`, data)
         .then((response) => {
            setSuccess(true)
            if (view === "Pending" || view === "Accepted" || view === "Rejected") {
               setMessage(
                  "Your request is submitted and the Part(s)/Specification(s) will be moved after few minutes.",
               )
               setSendSelectedIds([])
               setSelectedRowIds([])
               setSelectedNames([])
               setSelectAllRows(false)
            } else {
               setMessage(
                  "The action performed on the selected Part(s)/Specificatio(s) is in process. Please refresh the screen after few minutes.",
               )
            }

            setTimeout(() => {
               setMessage("")
            }, 3000)
         })
         .catch((error) => {
            if (error.response && error.response.status) {
               console.log(error.response.status, error.response.data.message)
            } else {
               console.log(1000, error)
            }
            setSuccess(false)
            setMessage(
               "Vendor service issue. Please contact SpecReaderExt.im@pg.com for help.",
            )
            setTimeout(() => {
               setMessage("")
            }, 3000)
         })
   }

   function handleOnClick(event) {
      const selectedIds = selectedRowIds
      const selectedPartNames = selectedNames
      const viewName = view === "Rejected" ? "Rejected Specifications" : view
      if (selectedRowIds.length !== 0) {
         let data = {}
         let alertMsg = ""
         if (event === "RemoveFromFavorite") {
            data = {
               ebpstate: "Accepted",
               favourite: false,
               ebpid: selectedIds,
               ebpName: selectedPartNames,
               event: "to remove from Favorites",
               vendor: siteInfo,
            }
            alertMsg =
               "The selected part(s) will be removed from Favorites View. Do you wish to continue?"
         } else if (event === "MoveToFavorite") {
            data = {
               ebpstate: "Accepted",
               favourite: true,
               ebpid: selectedIds,
               ebpName: selectedPartNames,
               event: `from ${viewName} to Favorites`,
               vendor: siteInfo,
            }
            if (view === "Pending") {
               alertMsg = `Moving parts to Favorites View indicate the parts are Accepted by [${siteInfo}]. Selected Parts will be removed from Pending Specifications View. Do you wish to proceed?`
            } else if (view === "Accepted") {
               alertMsg =
                  "The selected part(s) will be added to Favorites View. Do you wish to continue?"
            }
         } else if (event === "MoveToSummary") {
            data = {
               ebpstate: "Accepted",
               favourite: false,
               ebpid: selectedIds,
               ebpName: selectedPartNames,
               event: `from ${viewName} to Accepted Specifications`,
               vendor: siteInfo,
            }
            if (view === "Pending") {
               alertMsg = `Moving parts to Accepted Specifications View indicate the parts are Accepted by [${siteInfo}]. Selected Parts will be removed from Pending Specifications View. Do you wish to proceed?`
            }
         } else if (event === "MoveToP&G") {
            data = {
               ebpstate: "Rejected",
               favourite: false,
               ebpid: selectedIds,
               ebpName: selectedPartNames,
               event: `from ${viewName} to Rejected Specifications`,
               vendor: siteInfo,
            }
            if (view === "Pending") {
               alertMsg = `Moving parts to Rejected Specifications indicate the parts are Rejected by [${siteInfo}]. Selected Parts will be moved to Rejected Specifications View. Do you wish to proceed?`
            }
         } else if (event === "MoveToPending") {
            data = {
               ebpstate: "Pending",
               favourite: false,
               ebpid: selectedIds,
               ebpName: selectedPartNames,
               event: `from ${viewName} to Pending Specifications`,
               vendor: siteInfo,
            }
            if (view === "Rejected") {
               alertMsg = `Selected Parts will be moved to Pending Specifications View for [${siteInfo}]. Do you wish to proceed?`
            }
         }
         setMoveData(data)
         moveOrRemove(data, alertMsg)
      } else {
         alert("You must select one or more parts for the selected Action")
      }
   }

   const moveOrRemove = (toMoveData, alertMsg) => {
      let deleteForm
      deleteForm = window.confirm(alertMsg)
      if (deleteForm && alertMsg !== "" && toMoveData.ebpstate === "Rejected") {
         setShow(true)
      } else if (toMoveData.ebpstate === "Pending" && deleteForm && alertMsg !== "") {
         setShowUnrejectModal(true)
      } else {
         if (deleteForm) {
            moveFromView(toMoveData)
         }
      }
   }

   function handlePageChange(pageNumber) {
      setCurrentPage(pageNumber)
      setActivePage(pageNumber)
   }

   useEffect(() => {
      if (view == "Accepted") {
         setDynamicAction(SummaryViewActions)
      } else if (view == "Favorites") {
         setDynamicAction(FavoritesViewActions)
      } else if (view == "Pending") {
         setDynamicAction(PendingViewActions)
      } else if (view == "Rejected") {
         if (userRole !== "CM" && userRole !== "SP" && employee === "PG") {
            setDynamicAction(RejectedViewActionsInternals)
         } else {
            setDynamicAction("")
         }
      } else {
         setDynamicAction([])
      }
   }, [view])

   useEffect(() => {
      fetchData()
   }, [results])
   useEffect(() => {
      handleSearchChange1(search)
   }, [search, handleSearchChange1])
   useEffect(() => {
      dataRef.current = vendors
   }, [vendors])

   function formatDate(inputDate) {
      if (!inputDate) return ""
      const [month, day, year] = inputDate.split("/")
      if (!month || !day || !year) return ""
      const dateObj = new Date(`${year}-${month}-${day}`)
      if (isNaN(dateObj.getTime())) return ""
      const monthNames = [
         "Jan",
         "Feb",
         "Mar",
         "Apr",
         "May",
         "Jun",
         "Jul",
         "Aug",
         "Sep",
         "Oct",
         "Nov",
         "Dec",
      ]
      return `${day}-${monthNames[parseInt(month, 10) - 1]}-${year}`
   }

   function toInputDate(mmddyyyy) {
      if (!mmddyyyy) return ""
      const [month, day, year] = mmddyyyy.split("/")
      if (!month || !day || !year) return ""
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`
   }

   function handleClearFilter(CalledFrom) {
      if (CalledFrom == "Clear") {
         setOrgName("")
      }
      setSearching(false)
      setResultsPerPage(20)
      setCurrentPage(1)
      setShowDateRangeFieldsMsg(false)
      setShowMonthFieldMsg(false)
      setShowDateFieldMsg(false)
      setShowPreferenceDateMsg(false)
      inputRef.current.value = ""
      setActivePage(1)
      setFilterDates((dates) => ({
         ...dates,
         sortDateByRange: false,
         fromdateformat: "",
         todateformat: "",
         selectdateformat: "",
         sortDateByRange: false,
         sortByDate: false,
         sortByDateMessage: false,
         sortDateByRangeMessage: false,
         sortByMonth: false,
         sortByMonthMessage: false,
         firstOfMonth: "",
         lastOfMonth: "",
         filtered: false,
      }))
      setSelectedRowIds([])
      setSelectedNames([])
      setSelectAllRows(false)
      setFilteredData([])
      setActualFilteredData([])
      setDataSearched([])
      if (!showFilter) {
         setShowFilter(true)
      }
   }

   const handleAlertExcel = () => {
      alert(
         "There is an issue downloading the file.Please contact SpecReaderExt.im@pg.com for help.",
      )
   }

   useEffect(() => {
      fetchDataAllSpecificationData()
   }, [sbmView, siteInfo])

   useEffect(() => {
      if (view === "Pending" && !prefFilterApplied.current) {
         const fromPref = localStorage.getItem("fromPreferenceDate")
         const toPref = localStorage.getItem("toPreferenceDate")
         if (fromPref || toPref) {
            let effectiveFromDate = fromPref || ""
            let effectiveToDate = toPref || ""

            if (!fromPref || !toPref) {
               const relDates = (results || [])
                  .filter((item) => item && item.EBPModified != null)
                  .map((item) => new Date(item.EBPModified))
               if (relDates.length === 0) return // wait until results are loaded

               if (!fromPref && toPref) {
                  // Mirror handleDateByRange: use the oldest release date
                  const oldestDate = new Date(Math.min.apply(null, relDates))
                  effectiveFromDate = `${String(oldestDate.getMonth() + 1).padStart(2, "0")}/${String(oldestDate.getDate()).padStart(2, "0")}/${oldestDate.getFullYear()}`
               }
               if (fromPref && !toPref) {
                  // Use today's date as the to date
                  const today = new Date()
                  effectiveToDate = `${String(today.getMonth() + 1).padStart(2, "0")}/${String(today.getDate()).padStart(2, "0")}/${today.getFullYear()}`
               }
            }

            setFilterDates((dates) => ({
               ...dates,
               fromdateformat: effectiveFromDate,
               todateformat: effectiveToDate,
               sortDateByRange: true,
               filtered: false,
               sortByDate: false,
               sortByMonth: false,
            }))
            setShowDateRangeFields(false)
            setShowPreferenceDateMsg(true)
            prefFilterApplied.current = true
         }
      }
   }, [results])

   // Add pagination helper
   const totalPages = Math.ceil(
      (view !== "Search" ? finalData.length : results.length) / resultsPerPage
   )

   const renderPaginationItems = () => {
      const items = []
      const maxPagesToShow = 6
      let startPage = Math.max(1, activePage - Math.floor(maxPagesToShow / 2))
      let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1)

      if (endPage - startPage + 1 < maxPagesToShow) {
         startPage = Math.max(1, endPage - maxPagesToShow + 1)
      }

      if (activePage > 1) {
         items.push(
            <Pagination.First key="first" onClick={() => handlePageChange(1)} />,
            <Pagination.Prev key="prev" onClick={() => handlePageChange(activePage - 1)} />
         )
      }

      for (let page = startPage; page <= endPage; page++) {
         items.push(
            <Pagination.Item
               key={page}
               active={page === activePage}
               onClick={() => handlePageChange(page)}
            >
               {page}
            </Pagination.Item>
         )
      }

      if (activePage < totalPages) {
         items.push(
            <Pagination.Next key="next" onClick={() => handlePageChange(activePage + 1)} />,
            <Pagination.Last key="last" onClick={() => handlePageChange(totalPages)} />
         )
      }

      return items
   }

   return (
      <React.Fragment>
         {error === 4 && (
            <Row className="labels">
               <Col md={{ span: 6, offset: 3 }} align="center">
                  This is a highly connected part. There could be other Enterprise Parts
                  connected. &nbsp;
                  <a
                     href="#"
                     onClick={(e) => {
                        e.preventDefault()
                        highlyConnectedMessageFunction()
                     }}
                     style={{
                        color: "#007bff",
                        textDecoration: "underline",
                        cursor: "pointer",
                     }}
                  >
                     Click here to get data on email.
                  </a>
               </Col>
            </Row>
         )}
         {error === 2 && (
            <Row className="labels">
               <Col md={{ span: 6, offset: 3 }} align="center">
                  Vendor service issue. Please contact SpecReaderExt.im@pg.com for help
               </Col>
            </Row>
         )}
         {error === 3 && (
            <Row className="labels">
               <Col md={{ span: 6, offset: 3 }} align="center">
                  Please set Vendors/Sites in Preferences to see data in External Views.
               </Col>
            </Row>
         )}
         {error === 1 && (
            <Row className="labels" align="center">
               <Col md={{ span: 6, offset: 3 }}>No Records Found.</Col>
            </Row>
         )}
         {error === 0 && !fromViewMore && (
            <React.Fragment>
               <Container fluid className="searchDataContainer">
                  {(view === "Pending" ||
                     view === "Accepted" ||
                     view === "Rejected" ||
                     view === "Favorites") && (
                        <Row style={{ display: "flex", justifyContent: "flex-end" }}>
                           <Col xs="auto">
                              {loadingExcelData ? (
                                 <Button style={{ margin: "5px" }}>loading...</Button>
                              ) : downloadExcelData ? (
                                 <ExportToExcelAllSpecifications
                                    view={view}
                                    orgName={orgName}
                                    data={downloadExcelData}
                                    siteInfo={siteInfo}
                                 />
                              ) : (
                                 <Button
                                    onClick={handleAlertExcel}
                                    style={{ margin: "5px" }}
                                 >
                                    Export All Views
                                 </Button>
                              )}
                           </Col>
                        </Row>
                     )}
                  <Row className="mt-4 mb-3">
                     <Col md={6} sm={6} align="left">
                        <div style={{ width: "100%" }}>
                           <table style={{ width: "100%" }}>
                              <tbody>
                                 <tr>
                                    {view != "Search" && (
                                       <>
                                          <td
                                             style={{
                                                width: "30px",

                                                textAlign: "left",
                                             }}
                                          >
                                             Page Size
                                          </td>
                                          <td style={{ width: "10%" }}>
                                             <select

                                                value={resultsPerPage}
                                                onChange={(e) => {
                                                   setResultsPerPage(parseInt(e.target.value, 10))
                                                   setCurrentPage(1)
                                                   setActivePage(1)
                                                }}
                                                className="vendorOptionsSize form-control"
                                             >
                                                <option value="20">20</option>
                                                <option value="30">30</option>
                                                <option value="50">50</option>
                                             </select>
                                          </td>
                                       </>
                                    )}
                                    <td>
                                       <DropdownButton
                                          title="Action"
                                          style={{ width: "5%" }}
                                       >
                                          {dynamicAction &&
                                             userType === "PG" &&
                                             sbmView !== "SBM" &&
                                             dynamicAction.map((item, index) => (
                                                <Dropdown.Item
                                                   value={item.value}
                                                   key={index}
                                                   onClick={() =>
                                                      handleOnClick(item.value)
                                                   }
                                                >
                                                   {item.display}
                                                </Dropdown.Item>
                                             ))}
                                          <Dropdown.Item>
                                             <ExportToExcel
                                                view={view}
                                                data={exportData}
                                             />
                                          </Dropdown.Item>
                                       </DropdownButton>
                                    </td>
                                    {view === "Pending" && (
                                       <>
                                          <td>
                                             <DropdownButton
                                                title="Filter By"
                                                disabled={!showFilter}
                                             >
                                                <Dropdown.Item onClick={handleSortByDate}>
                                                   Date
                                                </Dropdown.Item>
                                                <Dropdown.Item
                                                   onClick={handleSortByDateRange}
                                                >
                                                   Date Range
                                                </Dropdown.Item>
                                                <Dropdown.Item onClick={handleSortByMonth}>
                                                   Month
                                                </Dropdown.Item>
                                             </DropdownButton>
                                          </td>
                                       </>
                                    )}
                                    <td>
                                       <Button
                                          style={{
                                             backgroundColor: "#007bff",
                                             marginLeft: "2px",
                                          }}
                                          onClick={() => handleClearFilter("Clear")}
                                       >
                                          Clear
                                       </Button>
                                    </td>
                                    <td>
                                       <div>
                                          <Form.Control
                                             className={
                                                view == "Pending"
                                                   ? "styleorg"
                                                   : "styleorg1"
                                             }
                                             type="input"
                                             id="orgName"
                                             value={orgName}
                                             placeholder="Search Organizations"
                                             onChange={searchChanges}
                                          />
                                       </div>
                                       <div
                                          className={
                                             view == "Pending" ? "styleorg" : "styleorg1"
                                          }
                                       >
                                          {showVendorContent && search !== "" && (
                                             <div className="ColGrowOrg">
                                                <div
                                                   style={{ border: "1px solid black" }}
                                                >
                                                   <ListGroup className="BusinessListpreferance1">
                                                      {vendor_content}
                                                   </ListGroup>
                                                </div>
                                             </div>
                                          )}
                                       </div>
                                    </td>
                                    <td>
                                       <Button
                                          style={{
                                             backgroundColor: "#007bff",
                                          }}
                                          onClick={() => handleOU()}
                                       >
                                          ...
                                       </Button>
                                    </td>
                                 </tr>
                              </tbody>
                           </table>
                        </div>
                     </Col>
                     {view !== "Search" && (
                        <>
                           <Col md={1} sm={1} align="right" style={{ paddingTop: "7px" }}>
                              Search:
                           </Col>
                           <Col md={2} sm={2} align="centre">
                              <Form.Control
                                 type="text"
                                 className="vendorOptions-homePage"
                                 ref={inputRef}
                                 onChange={handleSearchChange}
                              />
                           </Col>
                           <Col md={3} sm={3} align="right">
                              <div
                                 style={{ width: "40%", verticalAlign: "middle" }}
                                 id="paginTab"
                              >
                                 <Pagination className="pagination">
                                    {renderPaginationItems()}
                                 </Pagination>
                              </div>
                           </Col>
                        </>
                     )}
                  </Row>
                  {view === "Search" && (
                     <p
                        style={{ marginTop: "4px", fontWeight: "bold" }}
                        className={"alertMsg"}
                     >
                        {currentResult[0].highlyConnectedParts !== "" && (
                           <div>
                              <p className="alertMsg1">
                                 {" "}
                                 This is a highly connected part. There could be other
                                 Enterprise Parts connected. &nbsp;
                                 <a
                                    href="#"
                                    onClick={(e) => {
                                       e.preventDefault()
                                       highlyConnectedMessageFunction()
                                    }}
                                    style={{
                                       color: "#007bff",
                                       textDecoration: "underline",
                                       cursor: "pointer",
                                    }}
                                 >
                                    Click here to get data on email.
                                 </a>
                              </p>
                           </div>
                        )}
                     </p>
                  )}
                  {view === "Pending" && showPreferenceDateMsg ? (
                     <p
                        style={{ marginTop: "4px", fontWeight: "bold" }}
                        className="filteredDataMsg"
                     >
                        Filtered By Preference Date Range{" "}
                        {formatDate(filterDates.fromdateformat)} to{" "}
                        {formatDate(filterDates.todateformat)}
                     </p>
                  ) : view === "Pending" && showDateRangeFieldsMsg ? (
                     <p
                        style={{ marginTop: "4px", fontWeight: "bold" }}
                        className="filteredDataMsg"
                     >
                        Filtered By Date Range {formatDate(filterDates.fromdateformat)} to{" "}
                        {formatDate(filterDates.todateformat)}
                     </p>
                  ) : showDateFieldMsg ? (
                     <p
                        style={{ marginTop: "4px", fontWeight: "bold" }}
                        className="filteredDataMsg"
                     >
                        Filtered By Date {formatDate(filterDates.selectdateformat)}
                     </p>
                  ) : showMonthFieldMsg ? (
                     <p
                        style={{ marginTop: "4px", fontWeight: "bold" }}
                        className="filteredDataMsg"
                     >
                        Filtered By Month{" "}
                        {monthNames[new Date(filterDates.firstOfMonth).getMonth()]}-
                        {new Date(filterDates.firstOfMonth).getFullYear()}
                     </p>
                  ) : null}
                  {view === "Pending" && filterDates.sortDateByRange && (
                     <div>
                        <div className="row fthight">
                           <div className="col-sm-8  mt-3">
                              {showDateRangeFields && (
                                 <form>
                                    <div className="row mb-4">
                                       <label className="col-sm-2 col-form-label">
                                          From Date<span className="astriccolor">*</span>
                                       </label>
                                       <div className="col-sm-5">
                                          <input
                                             type="date"
                                             className="form-control"
                                             name="fromdate"
                                             placeholder="dd-mm-yyyy"
                                             max={toInputDate(filterDates.todateformat) && toInputDate(filterDates.todateformat) < todayStr ? toInputDate(filterDates.todateformat) : todayStr}
                                             onChange={(e) => handlefromdate(e)}
                                          />
                                          <span className="text-danger"> </span>
                                       </div>
                                    </div>

                                    <div className="row mb-4 ">
                                       <label className="col-sm-2 col-form-label">
                                          To Date<span className="astriccolor">*</span>
                                       </label>
                                       <div className="col-sm-5">
                                          <input
                                             type="date"
                                             className="form-control"
                                             name="todate"
                                             placeholder="dd-mm-yyyy"
                                             min={toInputDate(filterDates.fromdateformat) || undefined}
                                             max={todayStr}
                                             onChange={(e) => handletodate(e)}
                                          />
                                       </div>
                                    </div>

                                    <div className="row mb-4 ">
                                       <label className="col-sm-2 col-form-label"></label>
                                       <div className="col-sm-5">
                                          <Button
                                             style={{ backgroundColor: "#09f" }}
                                             onClick={handleDateByRange}
                                          >
                                             Submit
                                          </Button>
                                       </div>
                                    </div>
                                 </form>
                              )}
                           </div>
                        </div>
                     </div>
                  )}

                  {view === "Pending" && filterDates.sortByDate && (
                     <div>
                        <div className="row fthight">
                           <div className="col-sm-8  mt-3">
                              {showDateField && (
                                 <form>
                                    <div className="row mb-4">
                                       <label className="col-sm-2 col-form-label">
                                          Select Date
                                          <span className="astriccolor">*</span>
                                       </label>
                                       <div className="col-sm-5">
                                          <input
                                             type="date"
                                             className="form-control"
                                             name="selectdate"
                                             placeholder="dd-mm-yyyy"
                                             max={todayStr}
                                             onChange={(e) => handleSelectDate(e)}
                                          />
                                          <span className="text-danger"> </span>
                                       </div>
                                    </div>

                                    <div className="row mb-4 ">
                                       <label className="col-sm-2 col-form-label"></label>
                                       <div className="col-sm-5">
                                          <Button
                                             style={{ backgroundColor: "#09f" }}
                                             onClick={handleSelectDateSubmit}
                                          >
                                             Submit
                                          </Button>
                                       </div>
                                    </div>
                                 </form>
                              )}
                           </div>
                        </div>
                     </div>
                  )}

                  {view === "Pending" && filterDates.sortByMonth && (
                     <div>
                        <div className="row fthight">
                           <div className="col-sm-8  mt-3">
                              {showMonthField && (
                                 <form>
                                    <div className="row mb-4">
                                       <label className="col-sm-2 col-form-label">
                                          Select Month
                                          <span className="astriccolor">*</span>
                                       </label>
                                       <div className="col-sm-5">
                                          <input
                                             type="month"
                                             className="form-control"
                                             name="selectmonth"
                                             placeholder="mm-yyyy"
                                             max={todayYearMonth}
                                             onChange={(e) => handleSelectMonth(e)}
                                          />
                                          <span className="text-danger"> </span>
                                       </div>
                                    </div>

                                    <div className="row mb-4 ">
                                       <label className="col-sm-2 col-form-label"></label>
                                       <div className="col-sm-5">
                                          <Button
                                             style={{ backgroundColor: "#09f" }}
                                             onClick={handleMonthSubmit}
                                          >
                                             Submit
                                          </Button>
                                       </div>
                                    </div>
                                 </form>
                              )}
                           </div>
                        </div>
                     </div>
                  )}

                  <p
                     style={{ marginTop: "4px", fontWeight: "bold" }}
                     className={success ? "successMsg" : "alertMsg"}
                  >
                     {message}
                  </p>
                  {view != "Search" ? (
                     <CommonView
                        currentResult={currentResult}
                        requestSort={requestSort}
                        selectedRowIds={selectedRowIds}
                        totalItems={finalData}
                        getClassNamesFor={getClassNamesFor}
                        handleViewMorePart={handleViewMorePart}
                        isChecked={isChecked}
                        handleHeaderCheckBoxChange={handleHeaderCheckBoxChange}
                        handleRowCheckBoxChange={handleRowCheckBoxChange}
                        dataSearched={dataSearched}
                        searchInput={searchInput}
                        searching={searching}
                        pdfDisable={pdfDisable}
                        handlePDFDownload={handlePDFDownload}
                        view={view}
                     />
                  ) : (
                     <div style={{ overflow: "auto", maxHeight: "60vh" }}>
                        <Table bordered id="vendorInfoTable">
                           <thead id="infoTab" style={{ position: "sticky", top: -1, backgroundColor: "white", zIndex: 2 }}>
                              <tr>
                                 <th width="10%">Name&nbsp;</th>
                                 <th width="10%">Type &nbsp;</th>
                                 <th width="5%">Rev &nbsp;</th>
                                 <th width="10%">Title &nbsp;</th>
                                 <th width="15%">Impacted Part(s)&nbsp;</th>
                                 <th width="10%">Type &nbsp;</th>
                                 <th width="5%">Rev &nbsp;</th>
                                 <th width="10%">Title &nbsp;</th>
                              </tr>
                           </thead>
                           <tbody>
                              {(results || []).map((key, index) => {
                                 const impacted = key && key.ImpactedParts ? key.ImpactedParts : []
                                 if (impacted.length === 0) {
                                    return (
                                       <tr key={index}>
                                          <td width="10%">
                                             {key && key.link != null && key.id != null ? (
                                                <a href={`/${key.link.toUpperCase()}/${key.id}`} target="_blank" rel="noreferrer noopener">
                                                   <span>{key.Name || "N/A"}</span>
                                                </a>
                                             ) : (
                                                <span>{key ? key.Name || "N/A" : ""}</span>
                                             )}
                                          </td>
                                          <td align="left" width="10%">{key ? key.Type || "" : ""}</td>
                                          <td align="left" width="5%">{key ? key.Rev || "" : ""}</td>
                                          <td align="left" width="10%">{key ? key.Title || "" : ""}</td>
                                          <td align="left" width="15%"></td>
                                          <td align="left" width="10%"></td>
                                          <td align="left" width="5%"></td>
                                          <td align="left" width="10%"></td>
                                       </tr>
                                    )
                                 }
                                 return impacted.map((imp, impIndex) => (
                                    <tr key={`${index}-${impIndex}`}>
                                       {impIndex === 0 && (
                                          <>
                                             <td width="10%" rowSpan={impacted.length}>
                                                {key && key.link != null && key.id != null ? (
                                                   <a href={`/${key.link.toUpperCase()}/${key.id}`} target="_blank" rel="noreferrer noopener">
                                                      <span>{key.Name || "N/A"}</span>
                                                   </a>
                                                ) : (
                                                   <span>{key ? key.Name || "N/A" : ""}</span>
                                                )}
                                             </td>
                                             <td align="left" width="10%" rowSpan={impacted.length}>{key ? key.Type || "" : ""}</td>
                                             <td align="left" width="5%" rowSpan={impacted.length}>{key ? key.Rev || "" : ""}</td>
                                             <td align="left" width="10%" rowSpan={impacted.length}>{key ? key.Title || "" : ""}</td>
                                          </>
                                       )}
                                       <td align="left" width="15%">
                                          {imp && imp.link != null && imp.id != null ? (
                                             <a href={`/${imp.link.toUpperCase()}/${imp.id}`} target="_blank" rel="noreferrer noopener">
                                                <span>{imp.Name || "N/A"}</span>
                                             </a>
                                          ) : (
                                             <span>{imp ? imp.Name || "N/A" : ""}</span>
                                          )}
                                       </td>
                                       <td align="left" width="10%">{imp ? imp.DisplayType || "" : ""}</td>
                                       <td align="left" width="5%">{imp ? imp.Revision || "" : ""}</td>
                                       <td align="left" width="10%">{imp ? imp.Title || "" : ""}</td>
                                    </tr>
                                 ))
                              })}
                           </tbody>
                        </Table>
                     </div>
                  )}
               </Container>
            </React.Fragment>
         )}
         {selectedNames.length !== 0 && (
            <VendorMailModal
               show={show}
               setShow={setShow}
               selectedNames={selectedNames}
               moveFromView={moveFromView}
               moveData={moveData}
               sendSelectedIds={[...sendSelectedIds]}
            />
         )}

         {selectedNames.length !== 0 && (
            <UnrejectModal
               showUnrejectModal={showUnrejectModal}
               setShowUnrejectModal={setShowUnrejectModal}
               selectedNames={selectedNames}
               moveFromView={moveFromView}
               moveData={moveData}
               sendSelectedIds={[...sendSelectedIds]}
            />
         )}

         {vendors !== null && (
            <OrganizationData
               show={showOrganization}
               onHide={handleCloseOrganization}
               handleCloseOrganization={handleCloseOrganization}
               results={vendors}
               getOrganization={getOrganization}
               fetchDataOrganization={fetchDataOrganization}
               view={view}
               siteInfo={siteInfo}
            />
         )}
      </React.Fragment>
   )
}

export default VendorResults
